Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.notificationsReducer = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case types_1.NotificationsActionTypes.TRIGGER_NOTIFICATION:
            return state.concat([
                action.payload.notification,
            ]);
        case types_1.NotificationsActionTypes.CLOSE_NOTIFICATION:
            return state.filter(function (notification) {
                return notification.id !== action.payload.notificationId;
            });
        default:
            return state;
    }
};
